export default class {
  init() {
    const $elements = $("section.product-suggestions");

    if ($elements.length) {
      (async () => {
        const Vue = (await import("vue")).default;

        [...$elements].forEach((el) => {
          new Vue({
            data() {
              return {
                current: 0,
              };
            },
            mounted() {
              window.App.aos.refreshHard();
            },
          }).$mount(el);
        });
      })();
    }
  }
}
